"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitComponents = exports.Attribute = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Attribute =
/*#__PURE__*/
function () {
  function Attribute() {
    _classCallCheck(this, Attribute);
  }

  _createClass(Attribute, null, [{
    key: "parse",
    value: function parse(input) {
      switch (input[0]) {
        case '#EXTINF':
          return Attribute.parseInfo(input[1]);

        default:
          return Attribute.parseList(input[1]);
      }
    }
  }, {
    key: "parseList",
    value: function parseList(input) {
      if (typeof input === 'string') {
        var components = splitComponents(input);

        if (Object.keys(components).length == 0) {
          return stringOrNumber(clean(input));
        }

        return components;
      } else {
        return input;
      }
    }
  }, {
    key: "parseInfo",
    value: function parseInfo(input) {
      var result = {};
      var comps = input.split(',');
      result['duration'] = stringOrNumber(comps[0]);

      if (comps[1]) {
        result['title'] = comps[1];
      }

      return result;
    }
  }]);

  return Attribute;
}();

exports.Attribute = Attribute;

var splitComponents = function splitComponents(input) {
  return input.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(function (i) {
    return i.split('=');
  }).reduce(arrayToObject, {});
};

exports.splitComponents = splitComponents;

var arrayToObject = function arrayToObject(acc, cur) {
  if (cur[1]) {
    acc[cur[0]] = stringOrNumber(clean(cur[1]));
  }

  return acc;
};

var stringOrNumber = function stringOrNumber(input) {
  if (isNaN(input)) {
    return input;
  }

  return +input;
};

var clean = function clean(input) {
  return input.replace(/["]/g, '');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/playlist/attribute_list.js
// module id = 447
// module chunks = 0